// Split from api.ts so code that only needs the URL (the blog search embed)
// does not pull in axios.
export const API_BASE_URL =
  import.meta.env.VITE_API_URL?.replace(/\/$/, "") || "http://localhost:8080/api";
